import React from 'react';
import { PanelHeader } from 'js/components';
import { Breadcrumbs } from 'js/components/Breadcrumbs';
import { useParams } from 'react-router-dom';
import OrgTabs from './OrgTabs';

function OrgPageLayout({
  organization = null,
  orgLoadFailed = false,
  loading = false,
  children = null,
}) {
  const { workspaceId } = useParams();
  const orgTitle = organization?.name || 'Organization';
  const orgLoading = loading && !organization && !orgLoadFailed;
  const orgError = orgLoadFailed && !organization;

  const breadcrumbs = [
    { label: 'Organizations', to: `/w/${workspaceId}/orgs/` },
  ];

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className="content-fluid">
            <h1>{orgLoading ? 'Loading organization…' : orgTitle}</h1>
            {orgError && (
              <p className="text-danger mb-0">
                Unable to load this organization. It may not exist.
              </p>
            )}
          </div>
        </div>
        <div className="container-fluid">
          <OrgTabs />
        </div>
      </PanelHeader>
      <div className="content">{children}</div>
    </div>
  );
}

export default OrgPageLayout;
